import appConfig from '@nerdwallet/app-config';
import { getLogger } from '@nerdwallet/logging';
import { getCookie } from '../cookies';

import useAnalyticsContext from './useAnalyticsContext';

const segmentTrackingLogger = getLogger('SegmentTracking');

type DefaultPayload = {
  /* eslint-disable-next-line camelcase */
  deployable_name: string;
  /* eslint-disable-next-line camelcase */
  deployable_version: string;
};

const useAnalytics = () => {
  const { analytics } = useAnalyticsContext();
  const defaultPayload: DefaultPayload = {
    // eslint-disable-next-line no-underscore-dangle
    deployable_name: appConfig?._meta?.deployable,
    // eslint-disable-next-line no-underscore-dangle
    deployable_version: appConfig?._meta?.version,
  };

  const trackSegmentTrackEvent = (
    eventName: string,
    eventProps: Record<string, any> = {}
  ) => {
    try {
      analytics?.track(eventName, {
        ...defaultPayload,
        ...eventProps,
      });
    } catch (e) {
      segmentTrackingLogger.error(e);
    }
  };

  const trackSegmentPageEvent = (
    pageName: string,
    pageViewId: string
  ): void => {
    try {
      analytics.page(pageName, {
        pageview_id: pageViewId,
        traditional_device_id: getCookie('cookie_id'),
        ...defaultPayload,
      });
    } catch (e) {
      segmentTrackingLogger.error(e);
    }
  };

  return {
    trackSegmentTrackEvent,
    trackSegmentPageEvent,
  };
};

export default useAnalytics;
